/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Step5_RuleInputs */

const en_dr_step5_rule = /** @type {(inputs: Dr_Step5_RuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One sharp round of selection, not an endless discussion`)
};

const id_dr_step5_rule = /** @type {(inputs: Dr_Step5_RuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satu putaran seleksi yang tegas, bukan diskusi tanpa akhir`)
};

/**
* | output |
* | --- |
* | "One sharp round of selection, not an endless discussion" |
*
* @param {Dr_Step5_RuleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_step5_rule = /** @type {((inputs?: Dr_Step5_RuleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Step5_RuleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_step5_rule(inputs)
	return en_dr_step5_rule(inputs)
});